import dynamic from 'next/dynamic';
import React, { FC, ReactNode } from 'react';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

const SmallScreen: FC<{ children: ReactNode }> = ({ children }) => {
  return <MediaQuery maxWidth={1023}>{children}</MediaQuery>;
};

export default SmallScreen;
